<template>
  <div>
    <div class="bg-primary q-pa-md text-white text-weight-medium" v-if="title">
      <slot name="title">
        <p class="text-weight-bold">{{ title }}</p>
      </slot>
    </div>
    <div
      v-for="(row, index) in list"
      :key="index"
      :class="['q-pa-md', { 'bg-grey-2': isEven(index) }]"
    >
      <slot name="row" :row="row" :index="index">
        <div class="row items-center">
          <div class="row items-center col">
            <QIcon
              v-if="row[optionIcon]"
              name="eva-checkmark-outline"
              size="sm"
              class="q-mr-sm"
              color="primary"
            />
            <span class="text-paragraph">{{ row[optionLabel] }}</span>
          </div>
          <p class="text-weight-medium">
            {{ row[optionValue] }}
          </p>
        </div>
        <p
          v-if="row[optionSubLabel]"
          class="text-tab text-grey-6 q-mt-sm q-pl-lg q-ml-sm"
        >
          {{ row[optionSubLabel] }}
        </p>
      </slot>
    </div>
  </div>
</template>

<script>
import { QIcon } from 'quasar';

export default {
  name: 'SAITableSummary',
  props: {
    title: String,
    list: {
      type: Array,
      default: () => []
    },
    optionLabel: {
      type: String,
      default: 'label'
    },
    optionSubLabel: {
      type: String,
      default: 'disclaimer'
    },
    optionValue: {
      type: String,
      default: 'value'
    },
    optionIcon: String,
    frequency: String
  },
  methods: {
    isEven(value) {
      return value % 2 === 0;
    }
  },
  components: {
    QIcon
  }
};
</script>
